export default __webpack_public_path__ + "static/media/onboardingBg.e7362eb4.png";